import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=b11891d0"
var script = {}
import style0 from "./Policy.vue?vue&type=style&index=0&id=b11891d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports